

























































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { appModule } from "@/store/modules/app";
import KriteriaHcuSvc from "@/services/KriteriaHcuService";

@Component({
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class KriteriaHcuMasukSection extends Vue {
  @Prop() data!: any;
  @Prop() register!: string | number;
  @Prop() rm!: string | number;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  form: any = this.defaultForm();
  saving = false;
  signing = false;
  signDialog = false;
  signPassword = "";
  showPassword = false;
  signError = "";

  //  Urutan & teks mengikuti blanko RSPS revisi 30 Juli 2026
  readonly kriteriaItems = [
    { key: "km_gcs_lt12", label: "Penurunan Kesadaran GCS < 12" },
    { key: "km_syok", label: "Syok semua penyebab" },
    { key: "km_sepsis", label: "Sepsis / Awal Sepsis" },
    { key: "km_ich_gte20", label: "ICH ≥ 20 cc" },
    { key: "km_hemodinamik_tidak_stabil", label: "Hemodinamik Tidak Stabil" },
    { key: "km_meows_gte7", label: "Scor MEOWS ≥ 7 pada kasus maternitas" },
    { key: "km_oksigenasi_hfnc", label: "Oksigenasi pro HFNC" },
    { key: "km_kejang", label: "Kondisi kejang berulang / tidak terkontrol" },
    { key: "km_transportable", label: "Pasien masuk HCU transportable" },
  ];

  get isMasukLocked() {
    return this.data?.is_masuk_locked || false;
  }

  get validationError() {
    const hasKriteria = this.kriteriaItems.some(i => this.form[i.key] === true)
      || this.form.km_lainnya === true;
    if (!hasKriteria) return "Minimal 1 kriteria masuk harus dicentang";
    if (this.form.km_lainnya && !String(this.form.km_lainnya_text || "").trim()) {
      return "Kriteria lainnya harus diisi";
    }
    return "";
  }

  defaultForm() {
    return {
      km_gcs_lt12: false,
      km_syok: false,
      km_sepsis: false,
      km_ich_gte20: false,
      km_hemodinamik_tidak_stabil: false,
      km_meows_gte7: false,
      km_oksigenasi_hfnc: false,
      km_kejang: false,
      km_transportable: false,
      km_lainnya: false,
      km_lainnya_text: "",
      masuk_dokter_user_id: null,
    };
  }

  @Watch("data", { immediate: true })
  onDataChange() {
    if (this.data) {
      this.populateForm();
    }
  }

  populateForm() {
    const d = this.data;
    Object.keys(this.form).forEach(key => {
      if (d[key] !== undefined && d[key] !== null) {
        this.form[key] = d[key];
      }
    });
  }

  //  Mengembalikan record hasil simpan supaya doSign() punya id-nya SEKARANG:
  //  prop `data` baru terisi setelah induk selesai me-refresh store (asinkron,
  //  tidak ditunggu oleh emit), jadi membacanya tepat setelah simpan masih null
  //  pada form baru — itu yang dulu memaksa petugas menekan "Simpan Draft" dulu.
  //  `silent` dipakai doSign(): tanpa itu simpan memancarkan "saved" sehingga induk
  //  mulai me-refresh SEBELUM TTD selesai, dan refresh pra-TTD itu bisa menimpa
  //  hasil refresh pasca-TTD (masuk_signed_at hilang lagi -> tab Keluar tetap
  //  terkunci). Pola satu-emit ini mengikuti KriteriaIcuMasukSection.
  async saveDraft(silent = false) {
    this.saving = true;
    let saved: any = null;
    try {
      if (this.data?.id) {
        const resp = await KriteriaHcuSvc.update(this.data.id, this.form);
        if (resp?.data?.status === "1") {
          appModule.NoticeDelay("Berhasil menyimpan draft kriteria masuk");
          saved = resp.data.data;
          if (!silent) this.$emit("saved", resp.data.data);
        }
      } else {
        const payload = {
          ...this.form,
          register_id: this.register,
          pasien_rm: this.rm,
        };
        const resp = await KriteriaHcuSvc.create(payload);
        if (resp?.data?.status === "1") {
          appModule.NoticeDelay("Berhasil membuat kriteria masuk HCU");
          saved = resp.data.data;
          if (!silent) this.$emit("saved", resp.data.data);
        }
      }
    } catch (e) {
      // Error handled by service
    }
    this.saving = false;
    return saved;
  }

  openSignDialog() {
    if (this.validationError) return;
    this.signPassword = "";
    this.signError = "";
    this.signDialog = true;
  }

  async doSign() {
    if (!this.signPassword) {
      this.signError = "Password harus diisi";
      return;
    }

    this.signing = true;
    this.signError = "";

    try {
      // Save first — pakai id dari respons simpan, bukan prop `data` yang belum ter-update
      const saved = await this.saveDraft(true);
      const id = saved?.id || this.data?.id;

      if (!id) {
        this.signError = "Data harus disimpan terlebih dahulu";
        this.signing = false;
        return;
      }

      const resp = await KriteriaHcuSvc.signMasuk(id, {
        password: this.signPassword,
      });

      if (resp?.data?.status === "1") {
        appModule.NoticeDelay("Berhasil menandatangani kriteria masuk HCU");
        this.signDialog = false;
        this.$emit("signed");
      }
    } catch (e) {
      this.signError = "Gagal menandatangani. Periksa password Anda.";
    }

    this.signing = false;
  }
}
